import React, { useContext, useEffect, useState } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'

import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import { Context } from '../Context/DataContext';
import { apiRequest } from '../utils/apiCalls';
import { useHistory, useLocation } from 'react-router';
import BackButton from '../Components/BackButton';


const ViewSingleProd = () => {

    const location = useLocation();
    const { p_age, p_boxes, p_id, p_MSRP, p_color, p_manufacturer,
        p_type, p_name, p_price, p_status, pb_id,
    } = location?.state


    const history = useHistory();
    const [loading, setLoading] = useState(false)
    const { state } = useContext(Context)
    const [prodData, setProdData] = useState({
        p_id: p_id,
        p_name: p_name,
        p_price: p_price,
        p_age: p_age,
        p_status: p_status,
        p_MSRP: p_MSRP,
        p_color: p_color,
        p_manufacturer: p_manufacturer,
        p_type: p_type

    })

    function AddProd() {

        setLoading(true)
        console.log('mydata is')
        console.log(prodData)
        apiRequest(prodData, 'editprod')
            .then(data => {

                setLoading(false)
                console.log(data)
                if (data.status == '1') {
                    alert('Product Updated')
                    history.replace('viewProducts')
                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                console.log(err)
                alert("Network error")
                setLoading(false)
            })

    }


    function formatExpiry(expiry) {
        if (expiry == '1') return 'Daily'
        if (expiry == '7') return 'Weekly'
        if (expiry == '14') return 'Bi-Weekly'
        if (expiry == '30') return 'Monthly'
        else return expiry

    }





    return (
        <div>
            <div id="wrapper">
                <Sidebar />

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">
                    {/* Main Content */}
                    <div id="content">
                        <Topbar />

                        {/* Begin Page Content */}
                        <div className="container-fluid">
                            <Modal

                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Heading */}
                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                <h1 className="h3 mb-0 text-gray-800">View Product</h1>
                            </div>
                            <div className="row">
                                <form id="frm_product">
                                    <input type="hidden" name="ser_id" defaultValue={1} />
                                    <input
                                        type="hidden"
                                        name="g_name"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage name"
                                        defaultValue
                                        disabled={true}
                                    />
                                    <input
                                        type="hidden"
                                        name="g_phone"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage phone"
                                        defaultValue
                                    />
                                    <input
                                        type="hidden"
                                        name="g_email"
                                        className="form-control form-control-user"
                                        placeholder="From - Garage email"
                                        defaultValue
                                    />
                                    <div className="form-group row">
                                        <div className="col-sm-6">
                                            <div className="editDetails" >Name</div>
                                            <input
                                                type="text"
                                                name="p_name"
                                                id="p_name"
                                                title="Name"
                                                className="form-control form-control-user"
                                                placeholder="Name"
                                                value={prodData.p_name}
                                                disabled={true}
                                            />
                                            <br />
                                        </div>

                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Manufacturer</div>
                                            <input
                                            className="form-control form-control-user"
                                                value={prodData.p_manufacturer}
                                                disabled={true}
                                            />
                                            <br />
                                        </div>

                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Price</div>
                                            <input
                                                className="form-control form-control-user"
                                                placeholder="Price"
                                                value={prodData.p_price}
                                                disabled={true}
                                            />
                                            <br />
                                        </div>

                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >MSRP</div>
                                            <input
                                                type="number"
                                                name="MSRP"
                                                id="p_boxes"
                                                title=" MSRP (Manufacturer's Suggested Retail Price)"
                                                className="form-control form-control-user"
                                                placeholder="MSRP (Manufacturer's Suggested Retail Price)"
                                                value={prodData.p_MSRP}
                                                disabled={true}
                                            />
                                            <br />
                                        </div>

                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Color</div>
                                            <input
                                                type="text"
                                                name="Color"
                                                id="p_color"
                                                title="Color"
                                                className="form-control form-control-user"
                                                placeholder="Color"
                                                value={prodData.p_color}
                                                disabled={true}
                                            />
                                            <br />
                                        </div>

                                        <div className="col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Type</div>
                                            <input
                                                type="text"
                                                name="Color"
                                                id="p_color"
                                                title="Color"
                                                className="form-control form-control-user"
                                                placeholder="Type"
                                                value={prodData.p_type}
                                                disabled={true}
                                            />
                                            <br />
                                        </div>




                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Expiry</div>
                                            <select
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Expiry"
                                                value={prodData.p_age}
                                                disabled={true}
                                            >
                                                <option value selected disabled>
                                                    Expiry
                                                </option>
                                                <option value={1}>Daily</option>
                                                <option value={7}>Weekly</option>
                                                <option value={14}>Bi-Weekly</option>
                                                <option value={30}>Monthly</option>
                                            </select>
                                            <br />
                                        </div>
                                        <div className="center col-sm-6 mb-3 mb-sm-0">
                                            <div className="editDetails" >Status</div>
                                            <select
                                                name="p_status"
                                                id="p_status"
                                                title="Status"
                                                className="form-control form-control-user"
                                                placeholder="Status"
                                                value={prodData.p_status}
                                                disabled={true}
                                            >
                                                <option value selected disabled>
                                                    Status
                                                </option>
                                                <option value={1}>Active</option>
                                                <option value={0}>Inactive</option>
                                            </select>
                                            <br />
                                        </div>

                                    </div>
                                </form>
                            </div>
                            {/* /.container-fluid */}
                            <BackButton/>
                        </div>
                        
                        {/* End of Main Content */}
                    </div>
                    {/* End of Content Wrapper */}
                </div>
                {/* End of Page Wrapper */}
                {/* Scroll to Top Button*/}

                {/* Logout Modal*/}
                
            </div>

        </div>
    )
}

export default ViewSingleProd
